import { useContext } from 'react';
import ThemeContext from '../../store/theme-context';

const ExternalLink = (props) => {
    const theme = useContext(ThemeContext);
    return ( 
        <a href={props.href} target="_blank" className={`externalLinks ${props.className}`} style={{backgroundColor:theme.currentTheme.background, boxShadow: theme.currentTheme.boxShadow}}>{props.title}</a>
        );
}
 
export default ExternalLink;